const DATE_FORMAT = { day: "2-digit", month: "short", year: "numeric" };

export const getPlanDates = () => {
  const currentDate = new Date().toLocaleDateString("en-GB", DATE_FORMAT);
  const endDate = new Date();
  endDate.setDate(endDate.getDate() + 364);
  const formattedEndDate = endDate.toLocaleDateString("en-GB", DATE_FORMAT);
  return { currentDate, formattedEndDate };
};

export const getCoverageAmount = (planDescription) => {
  if (!planDescription || planDescription === "Protect") return "5,000";
  return "10,000";
};
